/**
 * Copyright 2023 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

export const PAGER_DUTY_URL = "https://events.pagerduty.com/v2/enqueue";
export const PAGER_DUTY_KEY_EXAMPLE = "e.g. 123e4567e89b12d3a456426655440000";
